export const getCurrentDay = () => {
    return (new Date())
        .toJSON()
        .slice(0, 10);
};
